import { WEB_AUTH_URL } from "../configurations/paths.config";
import { __enum_SystemPages, __SystemPagesPaths } from "./Dictionaries";

export const __onGoToProductHome = (url, history, contextSite) => {
    contextSite.setIspageIsHomeLanding(false);
    history.push({
        pathname: url,
    })
};

export const __onGoToCreateBook = () => {
    let url = `${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}`
    window.open(url, "_blank");
}

export const __onGoToBookLanding = () =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.HomeBook].text}`
    window.open(url, "_blank");
}

export const __onGoToManageElement = () =>{
    let url = __SystemPagesPaths[__enum_SystemPages.ElementConfiguration].text;
    window.open(url, "_blank");
};

export const __onGoToCreateBoard = (_boardId, history) => {
    history.push({
        pathname: `${__SystemPagesPaths[__enum_SystemPages.BoardCreation].text}/${_boardId}`
    }) 
};

//Deprecado, se debe cambiar cuando se aborde la nueva creación de board y configuración de board.
export const __onGoToBoard = (boardId) =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.Board].text}/${boardId}`, "_blank");
};

export const __onGoToNotificationPage= () =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.NotificationTasks].text}`, "_blank");
};

export const __onGoToBoardKpiOperational = (elementId, boardTypeId) =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.Board].text}/${elementId}/${boardTypeId}`, "_blank");
};

export const __onGoToBoardKpiConsolidated = (elementId, boardTypeId) =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.Board].text}/${elementId}/${boardTypeId}`, "_blank");
};

export const __onGoToReport = (elementId) =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.BoardReport].text}/${elementId}`, "_blank");
};

export const __onGoToPowerBI = (elementId) =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.PowerBI].text}/${elementId}`, "_blank");
};

export const __onGoToBoardV2 = (boardId) =>{
    window.open(`${__SystemPagesPaths[__enum_SystemPages.BoardV2].text}/${boardId}`, "_blank");
};

export const __onGoToGap = (gapAnalyzeId) => {
    let url = `${__SystemPagesPaths[__enum_SystemPages.GapV2].text}/${ gapAnalyzeId }`;
    window.open(url, "_blank");
};

export const __onGoToGapV2 = (elementId) => {
    let url = `${__SystemPagesPaths[__enum_SystemPages.GapV2].text}/${elementId}`;
    window.open(url, "_blank");
};

export const __onGoToMaintainer = (path, history) => {
    let url = `/forms/${ path }`;
    window.open(url, "_blank");
};

export const __onGoToIntegrationFG = (path, history) => {
    let url = `/Integration`;
    window.open(url, "_blank");
};

export const __onGoToConfigureBoard = (path, history) => {
    history.push({
        pathname: `/Kpi/Configuration/${ path }`
    })
};

export const __onGoToProfileClick = async () => {
    window.location.replace(`${WEB_AUTH_URL}`);
}

export const __onGoToBoardEP = (elementId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BoardEDP].text}/${elementId}`
    window.open(url, "_blank");
};

export const __onGoToRoles = (elementId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.Roles].text}/${elementId}`
    window.open(url, "_blank");
};

export const __onGoToBoardHome = () =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BoardLanding].text}`
    window.open(url, "_blank");
};

export const __onGoToBoardHomeCurrentTab = () =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BoardLanding].text}`
    window.open(url, "_self");
};

export const __onGoToKPIHome = () =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.HomeKPIV2].text}`
    window.open(url, "_blank");
};

export const __onGoToBoardContract = (elementId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BoardBusiness].text}/${elementId}`
    window.open(url, "_blank");
};

export const __onGoToBoardCartera = () =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BoardPortfolio].text}`
    window.open(url, "_blank");
};

export const __onGoToBook = (bookId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${bookId}`
    window.open(url, "_blank");
};

export const __onGoToConfigPartiesEP = (elementId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.ContactParties].text}/${elementId}`
    window.open(url, "_blank");
};
export const __onGoToContractualModifications = (elementId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.ContractModification].text}/${elementId}`
    window.open(url, "_blank");
};
export const __onGoToAMSAReport = (elementId) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.BoardReport].text}/${elementId}`
    window.open(url, "_blank");
};
export const __onGoToElementObligationAchives = (elementId, obligationIdSelected) =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.ElementObligations].text}/${elementId}/${obligationIdSelected}`
    window.open(url, "_blank");
};
export const __onGoToObligationControl = () =>{
    let url = `${__SystemPagesPaths[__enum_SystemPages.HomeObligations].text}`
    window.open(url, "_blank");
};